var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #ed3024;\n      }\n\n      .cls-3 {\n        fill: #0390cb;\n      }\n\n      .cls-4 {\n        fill: #00bae2;\n      }\n\n      .cls-5 {\n        fill: #f48326;\n      }\n\n      .cls-6 {\n        fill: #78a12f;\n      }\n\n      .cls-7 {\n        fill: #c7de8d;\n      }\n\n      .cls-8 {\n        fill: #9ed8ef;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.36,17.97l-.3.16c-7.19,5.92-10.64,14.32-10.97,20.42-.82-1.75-2.68-5.09-3.69-4.98s-1.69,1.64-1.85,5.55c-1.45-2.83-2.68-5.76-3.7-8.77-.35-.97-1.16-2.69-1.81-.31-.5,2.17-.81,4.39-.94,6.61.24,7.23,2.28,10.67,3.09,11.68-.76-.22-2.68-.11-1.8,2.23.99,3.02,3.38,5.38,6.42,6.33-4.31-.1-8.6-.7-12.78-1.77-1.84-.49-1.71.9.31,3.73,3.08,4.32,10.81,6,13.95,5.74,4.27-.39,6.22-1.57,7.71-2.63-1.17,2.88-6,5.81-7.77,6.43-2.54.9-1.11,1.74.74,1.97,3.19.32,6.36-.72,8.73-2.87.33,1.78-1.91,9.4-2.87,11.49-.59,1.27.3,2.77,3.01.58,2.97-2.18,5.38-5.04,7.02-8.35.52,1.72,1.09,4.05,1.41,5.55.25,1.13,1.17,1.21,2.09-.55.72-1.78,1.18-3.65,1.34-5.56,1.74,2.51,5.38,9.34,6.74,12.03.24.48,1.28,1.76,2.09-.41,1.64-4.38,1.1-10.86.34-14.18,1.68,1.88,3.17,3.92,4.43,6.1.82,1.64,2.07-.22,2.08-2.93,1.23.57,2.42,1.22,3.58,1.94.67.43,1.08.27,1.15-.52-.07-.85-.27-1.68-.6-2.46-1.53-3.8-4.59-4.26-7.08-4.1.3-2.37-.42-7.39-5.34-11.05,3.18.21,6.34.69,9.44,1.46,1.53.46,2.3-.16,2.04-1.26-.43-1.9-4.57-5.51-7.53-7.28,2.74-.03,5.48.11,8.21.42,1.26.16,1.79.22,1.98-.22s-.25-1.72-3.28-3.71c-3.18-1.93-6.75-3.14-10.45-3.54-1.35-.16-1.99-.15-2.82-.24.73-.52,4.1-.77,6.56-.67.99,0,1.22-.33.73-.9-1.21-1.38-4.06-1.99-5.36-1.91.2-.39,1.84-1.35,2.53-1.94s2.04-2.03-2.77-2.41c-4.6-.38-11.64,1.77-14.03,4.47-.11-4.81,3-16.8,3.7-18.87.82-2.46-.9-2.62-3.68-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m35.49,20.22c-3.64,2.94-8.12,7.86-9.85,14.82-2.46,9.75,5.74,19.2,5.85,19.22-.67-9.9,2.86-25.63,5.08-33.05.24-.82,0-1.09-.11-1.2s-.6-.09-.98.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m47.71,35.64c-6.93,4.86-13.06,10.3-16.23,18.62-1.6-2.7-1.22-6.4-.3-9.28,2.4-7.46,9.43-10.31,16.31-10.24.66,0,.91.41.21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m31.48,54.26c6.84-2.01,19.2-1.82,26.37,0,1.23.31,1.4-.66.82-1.36-3.42-4.17-7.39-6.78-12.94-7.22-6.59-.56-10.88,3.68-14.25,8.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m25.32,67.46c2.33-1.77,4.2-4.09,5.45-6.75,1.59,5.27-2.46,7.06-5.1,7.39-.49.06-.71-.36-.35-.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m31.48,54.26c1.93,7.06.89,15.48-1.03,22.66-.27,1.03.36,1.39,1.19.82,3.65-2.51,7.65-8.12,7.39-13.38-.32-5.65-2.68-8.87-7.52-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m31.48,54.26l18.46,22.68c.82,1.03,1.87.89,1.9-.39.15-5.83-1.75-21.39-20.37-22.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m31.48,54.26l8.8,17.31c.57,1.12,1.27,1.03,1.58-.28,1.11-4.48,2.12-14.61-10.38-17.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m59.31,46.72c-10.21.95-15.31-.34-27.81,7.55,6.15-16.48,20.86-13.7,27.79-9.03.94.63.73,1.44,0,1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m52.63,63.8c-4.73-3.77-14.58-8.76-21.15-9.54,1.96-1.36,4.21-2.24,6.56-2.58,7.25-1.15,13.7,3.83,15.7,11.49.26,1.01-.36,1.21-1.12.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m15.27,34.64c3.83,8.02,8.57,15.21,16.21,19.62-2.83,1.38-6.56.59-9.25-.75-6.93-3.46-8.8-11.38-7.86-18.75.09-.71.51-.92.9-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m31.48,54.26c-6.43,4.23-14.66,4.1-21.07,2.73-.91-.19-1.16.6-.57,1.22,3.57,3.77,8.03,6.02,12.97,5.59,4.73-.41,8.94-4.19,8.67-9.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m31.48,54.26l-10.07-16.77c-.65-1.08-1.34-.94-1.57.39-.76,4.56-1,14.85,11.64,16.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m32.3,35.44c-6.71,5.49-6.65,12.5-.82,18.83-.35-5.25.48-12.16,1.64-18.58.13-.7-.09-.89-.88-.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.48,54.26c-5.45.7-10.83-1.46-15.49-4.02-.77-.43-1.14.07-.88.68,2.77,6.65,12.01,10.88,16.41,3.34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue04);
export default __webpack_public_path__ + "static/media/blue04.200439a342b6e7a4c3554e7cb05b47cd.svg";
export { ForwardRef as ReactComponent };